import styled, {css} from 'styled-components'
import {DialogBody, DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'

export const StyledActivityReportDialogBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 4}px;
    `
)

export const StyledActivityReportDialogFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        display: flex;
        gap: ${spacing * 2}px;
        justify-content: flex-end;
    `
)

export const StyledActivityReportEmptyHint = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${typography.textSm};
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding: ${spacing * 6}px ${spacing * 4}px;
        border-radius: 8px;
        background: ${palette.neutral[50]};
        color: ${palette.neutral[500]};
    `
)

export const StyledActivityReportErrorBox = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${typography.textSm};
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${spacing * 2}px;
        text-align: center;
        padding: ${spacing * 5}px ${spacing * 4}px;
        border-radius: 8px;
        background: ${palette.danger[50]};
        border: 1px solid ${palette.danger[200]};
        color: ${palette.danger[700]};

        & svg {
            flex-shrink: 0;
        }
    `
)

export const StyledActivityReportFieldRow = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: ${spacing * 3}px;
        align-items: start;
    `
)

export const StyledActivityReportCountersGrid = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: ${spacing * 3}px;
    `
)

export const StyledActivityReportCounterCard = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 0.5}px;
        padding: ${spacing * 3}px;
        border-radius: 8px;
        background: ${palette.neutral[50]};
        border: 1px solid ${palette.neutral[200]};

        & > span.label {
            ${typography.textXs};
            color: ${palette.neutral[600]};
            font-weight: 500;
        }

        & > strong {
            ${typography.displayXs};
            font-weight: 500;
            color: ${palette.neutral[900]};

            & > i {
                ${typography.textMd};
                color: ${palette.neutral[500]};
            }
        }

        & > span.sublabel {
            ${typography.textXs};
            color: ${palette.neutral[500]};
        }
    `
)

export const StyledActivityReportToValidate = styled.span(
    ({theme: {spacing, palette, typography}}) => css`
        ${typography.textXs};
        display: flex;
        align-items: center;
        gap: ${spacing * 0.5}px;
        color: ${palette.orange[600]};

        & svg {
            flex-shrink: 0;
            color: ${palette.orange[600]};
        }
    `
)

export const StyledActivityReportWarningBanner = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${typography.textSm};
        display: flex;
        flex-direction: column;
        gap: ${spacing}px;
        padding: ${spacing * 3}px;
        border-radius: 8px;
        background: ${palette.orange[50]};
        border: 1px solid ${palette.orange[200]};
        color: ${palette.orange[900]};

        & .banner-header {
            display: flex;
            align-items: center;
            gap: ${spacing}px;
            font-weight: 600;
        }

        & b {
            font-weight: 500;
        }
    `
)

export const StyledActivityReportInfoBanner = styled.div<{$variant?: 'info' | 'error'}>(
    ({theme: {spacing, palette, typography}, $variant = 'info'}) => css`
        ${typography.textSm};
        display: flex;
        flex-direction: column;
        gap: ${spacing}px;
        padding: ${spacing * 3}px;
        border-radius: 8px;
        background: ${$variant === 'error' ? palette.danger[50] : palette.primary[50]};
        border: 1px solid ${$variant === 'error' ? palette.danger[200] : palette.primary[200]};
        color: ${$variant === 'error' ? palette.danger[700] : palette.primary[900]};

        & .banner-header {
            display: flex;
            align-items: center;
            gap: ${spacing}px;
            font-weight: 600;
        }
    `
)

export const StyledActivityReportResultBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${spacing * 2}px;
        padding: ${spacing * 6}px ${spacing * 4}px;
        text-align: center;
    `
)

export const StyledActivityReportResultIcon = styled.div<{$variant: 'error' | 'success'}>(
    ({theme: {palette}, $variant}) => css`
        display: inline-flex;
        align-items: center;
        justify-content: center;

        svg {
            color: ${$variant === 'error' ? palette.danger[500] : palette.green[500]};
            fill: ${$variant === 'error' ? palette.danger[500] : palette.green[500]};
        }
    `
)

export const StyledActivityReportResultTitle = styled.h3(
    ({theme: {palette, typography}}) => css`
        ${typography.displayXs};
        font-weight: 600;
        color: ${palette.neutral[900]};
        margin: 0;
    `
)

export const StyledActivityReportResultSubtitle = styled.p(
    ({theme: {palette, typography}}) => css`
        ${typography.textSm};
        color: ${palette.neutral[600]};
        margin: 0;
    `
)
